module.exports = __webpack_public_path__ + "img/mail.390287ea.svg";